module.exports = __webpack_public_path__ + "static/media/coins-tex.be978cc4.png";